import React, { Component } from 'react';
import Container from '../../components/Container';
import { Grid, Drawer,CircularProgress, ListItem,ListItemIcon, Radio } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';
import { CheckIcon, VisaIcon, DeleteWhiteIcon, MasterIcon } from '../../components/icons';
import { isRetina } from '../../utils/util';
import { portalCfg } from '../../../portal.router.config';
import ButtonCustom from '../../components/ButtonCustom'
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { connection, custom_assets, domainName, portal_config } from '../../../portal.config';
import Paypal from '../../components/Paypal'
import FAC from '../../components/FAC';
import FormStripe from '../../components/FormStripe';
import Stripe from '../../components/Stripe';
import { getContacts } from '../../utils/common';

let path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo  ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
const logo = isRetina(path+"/images/home_logo.png", path+"/images/home_logo@2x.png")

const styles = theme => ({
    method_container:{
        padding: theme.spacing(4,0,0,0)
    },
    method_pre:{
        padding:theme.spacing(0,2,0,0)
    },
    method: {
        backgroundColor:theme.palette.background.secondary,
        borderRadius: theme.spacing(2),
        height: theme.spacing(12),
        padding: theme.spacing(1,4,1,4),
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]:{
            padding: theme.spacing(1,2,1,2),
        }
    },
    button_add:{
        marginTop: theme.spacing(10)
    },
    bg_icon:{
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    }
});
function CardsView(props) {
    const {classes, t, onCloseItem, cards, onOpenAddCard, setPrimaryCard, onRemoveCard, showLoading } = props
    const contactInfo = getContacts();
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={()=>onCloseItem('card')}
                title = {t('my_cards_orders')}
                enableBack
                children={
                    <Grid item>
                        {props.facs.length===0&&<Grid item>
                            <Grid xs={12} item container justify='center'>
                                <img src={logo}/>
                            </Grid>
                            <Grid xs={12} item container justify='center'>
                                <CustomTypo mg_top_xl color='onPrimary' variant='body2'>{t('add_to_cart_desc')}</CustomTypo>
                            </Grid>
                        </Grid>}
                        {showLoading&&<Grid xs={12} item container justify='center'><CustomizedCircularProgress/></Grid>}
                        {/* {cards.length>0&&cards.map((item,index)=><CardItem item = {item} classes={classes} setPrimaryCard={setPrimaryCard} onRemoveCard = {onRemoveCard}/>)} */}
                        {/* <ButtonCustom fullWidth color='primary' className={classes.button_add} onClick={onOpenAddCard} disableTextTransform={true}>{t('add_a_card')}</ButtonCustom> */}
                        {connection.crmConfig.isOpenPaypal && <Paypal showMessage={props.showMessage} setPrimaryCard={setPrimaryCard}  onRemoveCard = {onRemoveCard} paypals={props.paypals} onRefresh={props.onRefresh} t={t}/>}
                        {connection.crmConfig.isOpenFAC && contactInfo && contactInfo.country_agreement == 'TTO' && <FAC showMessage={props.showMessage} setPrimaryCard={setPrimaryCard}  onRemoveCard = {onRemoveCard} facs={props.facs} onRefresh={props.onRefresh} t={t}/>}
                        {connection.crmConfig.isOpenStripe && <Grid item xs={12}>
                            <CustomTypo mg_left_sm variant='caption1' color='onPrimary'>{'Your Stripe'}</CustomTypo>
                            <Stripe showMessage={props.showMessage} setPrimaryCard={setPrimaryCard}  onRemoveCard = {onRemoveCard} stripes={props.stripes} onRefresh={props.onRefresh} t={t}/>
                            <ButtonCustom fullWidth color='primary' className={classes.button_add} onClick={() => props.setShowFormStripe(true)} disableTextTransform={true}>{t('Add Card with Stripe')}</ButtonCustom>
                        </Grid>}
                        {props.showFormStripe && <FormStripe 
                            open={props.showFormStripe}
                            onClose={() => props.setShowFormStripe(false)}
                            setOpen={props.setOpen}
                            onRefresh={props.onRefresh}
                        />}
                </Grid>}/>
    </div>
    );
}
function CardItem(props){
    const {classes,item} = props
    //console.log('CardItem=== ',item)
    let card_holder_name = item.card&&item.card.card_holder_details&&item.card.card_holder_details.card_holder_name?item.card.card_holder_details.card_holder_name:""
    return(
        <Grid xs={12} item container className={classes.method_container}>
            <Grid xs={11} item className={classes.method_pre}>
                <Grid  item className={classes.method} container alignItems='center' onClick={() => props.setPrimaryCard(item.id)}>
                    <Grid xs={2} item container justify='flex-start'>
                        {item.brand === 'master' ? <MasterIcon /> : <VisaIcon />}
                    </Grid>
                    <Grid xs={8}  item>
                        <CustomTypo mg_left_sm variant='body1'>{item && item.card && item.card.last4 ? "**** **** **** " + item.card.last4 : ""}</CustomTypo>
                    </Grid>
                    {item.is_primary && <Grid xs={2}  item container justify='flex-end' >
                        <CheckIcon/>
                    </Grid>}
                </Grid>
            </Grid>
                <Grid xs={1} item container justify='flex-end' alignItems='center'>
                    <div className={classes.bg_icon} onClick={() => props.onRemoveCard(item)}>
                        <DeleteWhiteIcon />
                    </div>
                </Grid>
        </Grid>
    )
}
export default withStyles(styles)(withTranslation()(CardsView));